import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Trophy, ArrowUpRight } from 'lucide-react';
import TiltCard from './TiltCard';
import './ProjectCard.css';

const initials = (title) =>
  title
    .replace(/[^a-zA-Z0-9 ]/g, '')
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase();

const ProjectCard = ({ project, index = 0 }) => {
  const navigate = useNavigate();
  const [imgFailed, setImgFailed] = useState(false);
  const showImage = project.image && !imgFailed;

  return (
    <TiltCard
      className="pcard"
      layout
      initial={{ opacity: 0, y: 26 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      exit={{ opacity: 0, scale: 0.96, transition: { duration: 0.2 } }}
      transition={{ duration: 0.5, delay: (index % 3) * 0.08 }}
      onClick={() => navigate(`/project/${project.id}`)}
    >
      <div className="pcard__media">
        {showImage ? (
          <img
            src={project.image}
            alt={project.title}
            loading="lazy"
            decoding="async"
            onError={() => setImgFailed(true)}
          />
        ) : (
          <div className="pcard__fallback">
            <span>{initials(project.title)}</span>
          </div>
        )}
        {project.award ? (
          <span className="award-badge pcard__award">
            <Trophy size={12} /> Winner
          </span>
        ) : project.launched ? (
          <span className="live-badge pcard__live">Live</span>
        ) : null}
        <span className="pcard__year">{project.year}</span>
        <span className="pcard__open"><ArrowUpRight size={18} /></span>
      </div>

      <div className="pcard__body">
        <h3 className="pcard__title">{project.title}</h3>
        <p className="pcard__tagline">{project.tagline}</p>
        <div className="pcard__tech">
          {project.tech.slice(0, 4).map((t) => (
            <span className="chip" key={t}>{t}</span>
          ))}
          {project.tech.length > 4 && (
            <span className="chip">+{project.tech.length - 4}</span>
          )}
        </div>
      </div>
    </TiltCard>
  );
};

export default ProjectCard;
